<template>
  <div>
    <div class="app-container app-container--with-progress">
      <div class="app-container-route">
        <div v-if="membershipType" class="membership-selected">
          {{ membershipType }}
          <span />
        </div>

        <HeaderWithIcon title="Registration Complete" />

        <p>Thank you for registering.</p>

        <hr />

        <div class="actions">
          <a href="/profile" class="btn btn--positive">
            Go to My Account
          </a>
        </div>
      </div>
      <div class="app-container-progress">
        <progress-bar title="Register as a new member" />
      </div>
    </div>
    <spinner />
  </div>
</template>

<script>
// @ is an alias to /src
import ProgressBar from "@/components/ProgressBar.vue";
import Spinner from "@/components/Spinner";
import HeaderWithIcon from "@/components/HeaderWithIcon";
import { useMemberDetails } from "@/helpers/member-details";

export default {
  name: "ThankYou",
  components: {
    HeaderWithIcon,
    ProgressBar,
    Spinner,
  },
  setup() {
    const { membershipType } = useMemberDetails();

    return {
      membershipType,
    };
  },
};
</script>

<style lang="scss" scoped>
p {
  font-size: 14px;
  font-weight: 700;
  line-height: 28px;
}

.actions {
  margin-top: 4px;
  padding: {
    top: 16px;
    bottom: 16px;
  }
  text-align: right;

  .btn {
    min-width: 180px;
  }
}
</style>
